import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const FieldDescription = styled.div `
  ${typeStyle("captionM")};
  color: ${color("typeMeta")};
  margin-top: ${units(0.75)};
`;
